import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-seguros',
  templateUrl: './seguros.component.html',
  styleUrls: ['./seguros.component.scss']
})
export class SegurosComponent implements OnInit {

  constructor(
    private titleService: Title,
  ) {
    this.titleService.setTitle('Mundo Joven - Seguros');
   }

  ngOnInit() {
  }

  ngAfterContentInit(): void {
    // let quitado = false;
    setTimeout(() => {
      // while(!quitado){
        let hs = document.getElementsByTagName("link");
        for (var i = 0, max = hs.length; i < max; i++) {
          if (hs[i] && hs[i].href && hs[i].href.includes("append")) {
            hs[i].parentNode.removeChild(hs[i]);
            // quitado = true;
          }
        }
      // }
    }, 100);

    setTimeout(() => {

        let hs = document.getElementsByTagName("link");
        for (var i = 0, max = hs.length; i < max; i++) {
          if (hs[i] && hs[i].href && hs[i].href.includes("append")) {
            hs[i].parentNode.removeChild(hs[i]);
          }
        }
      
    }, 1000);

  }

}
